var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtHomeinsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424A56",
    fillRule: "nonzero",
    d: "M20.209.404C18.412 2.828 5.659 8 1 8c-.552 0-1 .448-1 1v19c0 4.356 3.765 8.939 9.989 13.542 3.998 2.956 9.532 6.101 10.766 6.413.16.041.33.041.49 0 1.103-.28 6.692-3.565 10.762-6.542C38.243 36.853 42 32.643 42 29V9c0-.552-.448-1-1-1C36.021 8 23.676 2.915 21.815.405c-.4-.54-1.206-.54-1.606 0zm.796 2.013l.092.08C24.56 5.396 34.472 9.41 39.893 9.942l.106.009L40 29c0 2.742-3.463 6.623-9.173 10.799-2.154 1.575-4.508 3.103-6.74 4.415l-.92.531c-.849.482-1.59.88-2.024 1.096l-.15.073-.062-.028c-.568-.262-1.773-.884-3.03-1.598-2.252-1.28-4.585-2.774-6.723-4.355l-.371-.276C5.288 35.506 2 31.429 2 28V9.945l.056-.005c5.22-.539 15.4-4.61 18.876-7.461l.073-.062z",
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4C5F2",
    d: "M21.422 11.234l-10 9v13c0 .553.448 1 1 1h5c.552 0 1-.447 1-1v-8c0-.553.448-1 1-1h4c.552 0 1 .447 1 1v8c0 .553.448 1 1 1h5c.552 0 1-.447 1-1v-13l-10-9z",
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5593E7",
    fillRule: "nonzero",
    d: "M22.035 9.444l.094.083 14 14c.39.39.39 1.024 0 1.415-.36.36-.928.388-1.32.083l-.094-.083L21.42 11.648l-6.283 6.284-.019.019-6.99 6.99c-.36.361-.928.389-1.32.084l-.094-.083c-.36-.361-.389-.928-.084-1.32l.084-.095 6.707-6.709v-4.584c0-.552.447-1 1-1 .513 0 .935.386.993.884l.007.116v2.584l5.293-5.29c.36-.361.927-.389 1.32-.084z",
    transform: "translate(3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtHomeinsurance);
export default __webpack_public_path__ + "static/media/art-homeinsurance.571eb86a19aacf11d4cf67c079585a4a.svg";
export { ForwardRef as ReactComponent };